/* @flow */
import * as React from 'react';
import { css } from 'linaria';

import FeatureBlock from './FeatureBlock';
import MediaQueries from '../../constants/MediaQueries';
import NumberedCircleBadge from './NumberedCircleBadge';

function SteppedFeatureBlock({
  layout,
  horizontalFigurePosition,
  step,
  body,
  figure,
  title,
}: {
  layout: 'vertical' | 'horizontal',
  horizontalFigurePosition?: 'left' | 'right',
  figure: any,
  body: any,
  title: any,
  step: string,
}) {
  let badge = (
    <NumberedCircleBadge className={Styles.Badge} key="badge">
      {step}
    </NumberedCircleBadge>
  );

  return (
    <FeatureBlock
      layout={layout}
      horizontalFigurePosition={horizontalFigurePosition}
      title={
        <div className={Styles.TitleWrap}>
          {badge}
          {title}
        </div>
      }
      figure={figure}
      body={body}
    />
  );
}

const Styles = {
  TitleWrap: css`
    ${MediaQueries.Medium} {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  `,
  Badge: css`
    margin: 0 auto 20px;
    ${MediaQueries.Medium} {
      margin: 0 16px 0 0;
    }
  `,
};

export default SteppedFeatureBlock;



// WEBPACK FOOTER //
// ./src/ui/components/core/SteppedFeatureBlock.js